import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SystemStatus from './SystemStatus';

export default function AdminDashboard() {
  const { user } = useAuth();

  return (
    <div className="page-shell">
      <section className="hero-panel hero-panel--admin">
        <div className="hero-copy">
          <p className="eyebrow">Panel admin</p>
          <h1>Operacion, tarifas y reglas desde una sola pantalla.</h1>
          <p className="hero-text">
            Este panel muestra el estado real del backend y te lleva directo a la administracion de tarifas maestras
            y reglas sin salir del flujo.
          </p>

          <div className="hero-actions">
            <Link to="/admin/tarifas" className="btn-primary btn-inline">
              Gestionar tarifas maestras
            </Link>
            <Link to="/admin/reglas" className="btn-secondary btn-inline">
              Gestionar reglas
            </Link>
            <Link to="/admin/tiendanube" className="btn-secondary btn-inline">
              Tiendanube
            </Link>
          </div>
        </div>

        <div className="session-card">
          <p className="eyebrow">Sesion activa</p>
          <strong>{user?.email || 'Usuario autenticado'}</strong>
          <span>{user?.rol || 'Rol no disponible'}</span>
          <small>ID de usuario: {user?.usuarioId ?? '-'}</small>
        </div>
      </section>

      <section className="admin-grid">
        <SystemStatus
          compact
          title="Estado de integracion"
          subtitle="API, DB y conteos reales para validar la operacion en linea."
        />

        <div className="panel quick-panel">
          <p className="eyebrow">Acceso rapido</p>
          <h2>Gestiona el catalogo vivo</h2>
          <div className="admin-links">
            <Link to="/admin/tarifas" className="link-card">
              <strong>Tarifas maestras</strong>
              <span>Crear, editar, filtrar y eliminar maestros reales.</span>
            </Link>
            <Link to="/admin/reglas" className="link-card">
              <strong>Reglas</strong>
              <span>Administrar reglas por maestro con rangos y precios reales.</span>
            </Link>
            <Link to="/admin/tiendanube" className="link-card">
              <strong>Tiendanube</strong>
              <span>Vincular clientes y revisar el estado de la integracion.</span>
            </Link>
            <Link to="/" className="link-card">
              <strong>Cotizador</strong>
              <span>Volver al flujo de cotizacion operativo.</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
